import { render } from "./viewComponent.vue?vue&type=template&id=1ef14852&scoped=true"
import script from "./viewComponent.vue?vue&type=script&lang=js"
export * from "./viewComponent.vue?vue&type=script&lang=js"

import "./viewComponent.vue?vue&type=style&index=0&id=1ef14852&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef14852"]])

export default __exports__